import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';
import { BookingRoomQuery } from '../gql/graphql';

const bookingRoom = graphql(/* GraphQL */ `
  query bookingRoom($bookingId: Int!) {
    bookingRooms(bookingId: $bookingId) {
      bookingId
      typeId
      numberOfRooms
      pricePerRoom
    }
  }
`);

const useGetBookingRoom = (bookingId: number) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const { data, isLoading } = useQuery<BookingRoomQuery>({
    queryKey: ['bookingRoom', bookingId],
    queryFn: async () =>
      graphqlRequest<BookingRoomQuery>(
        bookingRoom,
        { bookingId },
        isAuthenticated ? getAccessTokenSilently : undefined,
      ),
    enabled: isAuthenticated,
    staleTime: 3600000,
    retry: shouldRetryQuery,
  });

  return {
    bookingRoom: data,
    bookingRoomLoading: isLoading,
  };
};

export default useGetBookingRoom;
